import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import moment from 'moment'
import { Table, Menu, Label, Button, Segment, Message,
   Input, Pagination, Form, Select } from 'semantic-ui-react';
import _ from 'lodash';
import ModalDetail from './ModalDetail';
import ExportSTS from './ExportSTS'
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import { isAdmin, isOpd } from '../../../../../_utils/localstorage';
import ModalEdit from './ModalEdit';
import swal from 'sweetalert'
import { toIDR } from '../../../../../_utils/tocurrency';


export default class ListSTS extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         direction: null,
         requests: true,
         activePage: 1,
         totalPages: 0,
         itemPerPage: 0,
         totalItem: 0,
         q :"",

         is_detail: false,
         data_detail: null,
         loading_detail: false,

         is_edit: false,
         data_edit: null,
         loading_edit: false,

         is_export: false,
         isFilter: false,

         focused: null,
         startDate: null,
         endDate: null,
         focusedInput: null,
         pageActive: 1,
         status: 2,

      }

      this.searchSts = this.searchSts.bind(this);
      this.onCloseDetail = this.onCloseDetail.bind(this);
      this.onOpenDetail = this.onOpenDetail.bind(this);
      this.onFilter = this.onFilter.bind(this);      
      this.onCloseExport = this.onCloseExport.bind(this);
      this.onOpenExport = this.onOpenExport.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
      this.onOpenEdit = this.onOpenEdit.bind(this);
      this.onCloseEdit = this.onCloseEdit.bind(this);
      this.onChangeStatus = this.onChangeStatus.bind(this);
   }
   
   onOpenEdit = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_edit: true,
         data_edit: data[index],
         loading_edit: false
      });
   }

   onCloseEdit = () => {
      this.onRefresh();
      this.setState({
         is_edit:false,
         data_edit:null
      });
   }

   onRefresh(){
      this.setState({
         startDate: null,
         endDate: null,
         q: "",
         requests: true
      })

      fetch(`${BaseURLDev}/stsall?status=${this.state.status}`, { headers })
      .then(response => {
         if(!response.ok){
            swal('Load data gagal',  { icon:'error' })
            this.setState({data: [], requests: false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
      .catch(e => {
         this.setState({
            requests:false,
         })
         swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
            icon: "error",
         });
      })
   }

   onFilter(){
      const { startDate, endDate, status } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      this.setState({ requests: true, isFilter: true, q: "" })
      fetch(`${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}`, { headers })
      .then(response => {
         if(!response.ok){
            swal('Load data gagal',  { icon:'error' }) 
            this.setState({ data: [], requests: false });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   onOpenDetail = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_detail:true,
         data_detail:data[index],
      });
   }

   onCloseDetail = () => {
      this.setState({
         is_detail:false,
         data_detail:null
      });
   }

   onCloseExport = () => this.setState({is_export:false})
   onOpenExport = () => this.setState({is_export:true})

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   defaultState(stateData){
      this.setState({
         data: stateData.data,
         totalPages: stateData.totalPage,
         requests: false,
         totalItem: stateData.totalItem,
         itemPerPage: stateData.itemPerPage,
         isFilter: false
      })
   }

   componentDidMount(){
      fetch(`${BaseURLDev}/stsall?status=${this.state.status}`, { headers })
      .then(response => {
         if(!response.ok){
            swal('Load data gagal',  { icon: 'error' })         
            this.setState({data: [], requests: false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
      .catch(e => {
         this.setState({
            requests:false,
         })
         swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
            icon: "error",
         });
      })
   }

   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }

      const { startDate, endDate, status } = this.state
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD')
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD')

      this.setState({ activePage, pageActive: activePage, requests: true, isFilter: true })
      var url = null;
      if(this.state.q !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&page=${activePage}&q=${this.state.q}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&page=${activePage}`         
      }

      fetch(url,{ headers })
      .then(response => {
         if(!response.ok){
            swal('Load data gagal',  { icon:'error' })
            this.setState({data: [], requests: false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   } 

   searchSts(e) {
      this.setState({ q: e.target.value, requests: true });
      const { startDate, endDate, status } = this.state;
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      var url = null;
      if(e.target.value !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}&q=${e.target.value}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${status}`         
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            swal('Load data gagal',  { icon:'error' })             
            this.setState({ data: [], requests: false });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }

   onChangeStatus(e, el){
      this.setState({ status: el.value, requests: true, isFilter: true });
      const { startDate, endDate, q } = this.state;
      const start_date = startDate===null ? null : startDate.format('YYYY-MM-DD');
      const end_date = endDate===null ? null : endDate.format('YYYY-MM-DD');
      var url = null;
      if(q !== ""){
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${el.value}&q=${q}`
      }else{
         url = `${BaseURLDev}/stsall?start=${start_date}&end=${end_date}&status=${el.value}`         
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            this.setState({ requests: false });
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => this.defaultState(resJSON))
   }
   
   render() {
      const { column, data, direction, activePage } = this.state;
      const status_opt = [
         {'key': 0, 'text': 'Terverifikasi', 'value': 1},
         {'key': 1, 'text': 'Belum Terverifikasi', 'value': 0},
         {'key': 2, 'text': 'Semua Status', 'value': 2},
      ];
      return (
         <div>
            <div>         
               <Message
                  error
                  header='** Penting!'
                  content='Data yang tampil sebelum filter adalah data STS 3 hari terakhir.'
               />           
                  <Menu>
                     <Menu.Item>
                        <Form.Field 
                           control={Select} 
                           search 
                           onChange={this.onChangeStatus} 
                           options={status_opt} 
                           placeholder='Pilih Status'
                        /> 
                    </Menu.Item>
                     <Menu.Item>
                        <DateRangePicker
                           hideKeyboardShortcutsPanel
                           reopenPickerOnClearDates
                           showClearDates
                           minimumNights={0}
                           withPortal
                           showDefaultInputIcon
                           displayFormat="DD/MM/YYYY"
                           small={true}                              
                           numberOfMonths={2}
                           startDatePlaceholderText="Awal"
                           endDatePlaceholderText="Akhir"
                           startDateId="startDateId"
                           endDateId="endDateId"
                           isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                           startDate={this.state.startDate}
                           endDate={this.state.endDate}
                           onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                           focusedInput={this.state.focusedInput}
                           onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        />
                     </Menu.Item>
                     <Menu.Item>                     
                        <Button.Group size='small'>
                           <Button content="Filter" disabled={(this.state.startDate===null && this.state.endDate===null) || this.state.isFilter} color='green' icon='filter' onClick={this.onFilter}/>
                           <Button content="Export" disabled={this.state.requests} color='red' icon='download' onClick={this.onOpenExport} />
                           <Button color='blue' disabled={this.state.requests} content="Refresh" icon='refresh' onClick={this.onRefresh} />                        
                        </Button.Group>
                     </Menu.Item>
                     <Menu.Item>
                        <Input type="text"
                           icon="search"
                           placeholder="Masukkan Nomor STS"
                           autoFocus 
                           value={this.state.q}
                           style={{width:'300px'}}
                           onChange={this.searchSts} 
                           />
                     </Menu.Item>
                  </Menu>
                  <Segment loading={(this.state.loading_detail || this.state.requests)}>
                     <Table size='small' sortable celled>
                        <Table.Header>
                           <Table.Row>
                              <Table.HeaderCell colSpan='8'>
                                 <Pagination activePage={activePage} 
                                    onPageChange={this.handlePaginationChange} 
                                    totalPages={this.state.totalPages}
                                 />
                              </Table.HeaderCell>
                           </Table.Row>
                           <Table.Row>
                              <Table.HeaderCell style={{width:"3%",textAlign:"center"}}>No.</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"5%",textAlign:"center"}}>Proses</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"15%"}} sorted={column === 'no_sts' ? direction : null} onClick={this.handleSort('no_sts')}>
                                 Nomor STS
                              </Table.HeaderCell>
                              <Table.HeaderCell style={{width:"6%"}} sorted={column === 'created_at' ? direction : null} onClick={this.handleSort('created_at')}>
                                 Pembuatan
                              </Table.HeaderCell>
                              <Table.HeaderCell style={{width:"6%"}} sorted={column === 'tgl_realisasi' ? direction : null} onClick={this.handleSort('tgl_realisasi')}>
                                 Realisasi
                              </Table.HeaderCell>
                              {/* <Table.HeaderCell style={{width:"20%"}}>Verifikator</Table.HeaderCell> */}
                              <Table.HeaderCell style={{width:"6%"}}>Total BP</Table.HeaderCell>
                              <Table.HeaderCell>Total Nilai</Table.HeaderCell>
                              <Table.HeaderCell style={{width:"30%"}}>Keterangan</Table.HeaderCell>

                           </Table.Row>
                        </Table.Header>
                        <Table.Body>
                           {data.length===0 && 
                              <Table.Row>
                                 <Table.Cell colSpan="8">Data tidak ditemukan</Table.Cell>                           
                              </Table.Row>}
                           {data.map((item,i) => (
                              <Table.Row key={i} style={!item.tgl_realisasi ? {"backgroundColor":"#f9cecd"} : {} }>  
                                 <Table.Cell>{i+1+(activePage-1)*this.state.itemPerPage}.</Table.Cell>
                                 <Table.Cell style={{width:"5%",textAlign:"center"}}>
                                    <Button.Group size='mini'>
                                       <Button
                                          color='blue'
                                          icon='block layout'
                                          index={i}                                          
                                          onClick={this.onOpenDetail}
                                       />
                                       {isOpd() &&
                                          <Button
                                             color='green'
                                             icon='pencil'
                                             index={i}
                                             disabled={item.is_verified}
                                             onClick={this.onOpenEdit}
                                          />
                                       }
                                    </Button.Group>
                                 </Table.Cell>
                                 <Table.Cell>{item.no_sts}</Table.Cell>
                                 <Table.Cell>{toDMYDate(item.created_at)}</Table.Cell>
                                 <Table.Cell>
                                    {item.tgl_realisasi ? toDMYDate(item.tgl_realisasi) : "-" }
                                 </Table.Cell>
                                 <Table.Cell>{item.total_bp} BP</Table.Cell>
                                 <Table.Cell>{toIDR(item.total_nilai)}</Table.Cell>
                                 {/* <Table.Cell>
                                    {item.bank===null ? "-": item.bank.nama_bank}
                                 </Table.Cell> */}
                                 <Table.Cell>{item.keterangan}</Table.Cell> 
                              </Table.Row>
                           ))}
                        </Table.Body>
                        <Table.Footer>
                           <Table.Row>
                              <Table.HeaderCell colSpan='8'>
                                 <Pagination activePage={activePage} 
                                    onPageChange={this.handlePaginationChange} 
                                    totalPages={this.state.totalPages}
                                 />
                              </Table.HeaderCell>
                           </Table.Row>
                        </Table.Footer>                     
                     </Table>
                  </Segment>
                  {this.state.is_edit && 
                     <ModalEdit 
                        open={this.state.is_edit}
                        data_edit={this.state.data_edit} 
                        onClose={this.onCloseEdit} />
                  }
                  {this.state.is_detail && 
                     <ModalDetail 
                        open={this.state.is_detail}
                        data_detail={this.state.data_detail} 
                        onClose={this.onCloseDetail} />
                  }

                  {this.state.is_export &&
                     <ExportSTS
                        open={this.state.is_export}
                        onClose={this.onCloseExport}
                        data={this.state.data}
                     />
                  }
               </div>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/ListSTS.js